module.exports = __webpack_public_path__ + "static/media/sponsorshipDefaultBackground.9991c4d3.jpg";